import { X } from "@phosphor-icons/react";

const SIZE_CHART = [
  { size: "XS", bust: "31-32", waist: "23-24", hips: "33-34", eu: "32" },
  { size: "S",  bust: "33-34", waist: "25-26", hips: "35-36", eu: "34" },
  { size: "M",  bust: "35-36", waist: "27-28", hips: "37-38", eu: "36" },
  { size: "L",  bust: "37-38", waist: "29-31", hips: "39-41", eu: "38" },
  { size: "XL", bust: "39-41", waist: "32-34", hips: "42-44", eu: "40" },
];

export default function FitGuideModal({ open, onClose }) {
  if (!open) return null;
  return (
    <>
      <div className="fixed inset-0 bg-[#1A1A1A]/60 backdrop-blur-sm z-[70]" onClick={onClose} data-testid="fit-guide-overlay" />
      <div className="fixed inset-0 z-[80] flex items-center justify-center p-4" data-testid="fit-guide-modal">
        <div className="bg-[#FAF8F5] w-full max-w-2xl max-h-[85vh] overflow-y-auto p-8 lg:p-12 fade-up">
          <div className="flex justify-between items-start mb-8">
            <div>
              <div className="overline text-[#4A1525] mb-2">Fit guide</div>
              <h2 className="font-serif text-4xl">Find your size</h2>
            </div>
            <button onClick={onClose} className="p-2" data-testid="close-fit-guide" aria-label="Close">
              <X size={22} weight="light" />
            </button>
          </div>

          <p className="text-[#5C5C5C] leading-relaxed mb-8">
            All measurements are in inches. For the most accurate fit, measure over unlined lingerie or bare skin. If you're between sizes, size up for comfort.
          </p>

          <table className="w-full text-sm border-collapse mb-8" data-testid="size-chart">
            <thead>
              <tr className="border-b border-[#1A1A1A]">
                <th className="overline text-left py-3">Size</th>
                <th className="overline text-left py-3">Bust</th>
                <th className="overline text-left py-3">Waist</th>
                <th className="overline text-left py-3">Hips</th>
                <th className="overline text-left py-3">EU</th>
              </tr>
            </thead>
            <tbody>
              {SIZE_CHART.map((row) => (
                <tr key={row.size} className="border-b border-[#E6DED5]">
                  <td className="py-3 font-serif text-lg">{row.size}</td>
                  <td className="py-3">{row.bust}"</td>
                  <td className="py-3">{row.waist}"</td>
                  <td className="py-3">{row.hips}"</td>
                  <td className="py-3">{row.eu}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="space-y-4 text-sm text-[#5C5C5C]">
            <div><span className="overline text-[#1A1A1A] block mb-1">Bust</span>Measure around the fullest part, keeping the tape parallel to the floor.</div>
            <div><span className="overline text-[#1A1A1A] block mb-1">Waist</span>Measure the narrowest part of your natural waistline, above the belly button.</div>
            <div><span className="overline text-[#1A1A1A] block mb-1">Hips</span>Measure around the fullest part of your hips, roughly 8" below your waist.</div>
          </div>
        </div>
      </div>
    </>
  );
}
